import React, { useState, useEffect } from "react";
import "../../styles/desktop/ar.css";

import { comandoAr } from '../../API/basic/AcionamentoAr';
import { statusAr } from '../../API/basic/FeedbackAr';

import arParedeLigado from "../../assets/img/areas_climatizacao/arCondicionado.png";
import arParedeDesligado from "../../assets/img/areas_climatizacao/arCondicionadoDesligado.png";

import arTetoLigado from "../../assets/img/areas_climatizacao/arCondicionadoTeto.png";
import arTetoDesligado from "../../assets/img/areas_climatizacao/arCondicionadoTetoDesligado.png";

import espacoImageGardenGourmet from "../../assets/img/areas_climatizacao/garden_gourmet.png";
import espacoImageBrinquedoteca from "../../assets/img/areas_climatizacao/brinquedoteca.png";
import espacoImageSalaDeJogos from "../../assets/img/areas_climatizacao/sala_de_jogos.png";
import espacoImageSalaoDeFestas1 from "../../assets/img/areas_climatizacao/salao_de_festas.png";
import espacoImageGourmet from "../../assets/img/areas_climatizacao/gourmet.png";
import espacoImageAcademia from "../../assets/img/areas_climatizacao/academia.png";
import espacoImageOffice from "../../assets/img/areas_climatizacao/Office.jpg";
import espacoImageMarket from "../../assets/img/areas_climatizacao/Market.jpg";

import voltar from "../../assets/mobile/icones/volte.png";

const ArCondicionado = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [espacoArCondicionados, setEspacoArCondicionados] = useState([
    { 
      nome: "Garden Gourmet", 
      espacoImg: espacoImageGardenGourmet, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 23, y: -1, rotate: "0deg" },
        { id: 2, tipo: "parede", status: false, x: 39, y: -1, rotate: "0deg" },
        { id: 3, tipo: "parede", status: false, x: 23, y: 78, rotate: "180deg" },
        { id: 4, tipo: "parede", status: false, x: 39, y: 78, rotate: "180deg" }
      ]
    },
    { 
      nome: "Brinquedoteca", 
      espacoImg: espacoImageBrinquedoteca, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 28, y: 16, rotate: "0deg" },
      ]
    },
    { 
      nome: "Sala de Jogos", 
      espacoImg: espacoImageSalaDeJogos, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 41, y: 14, rotate: "90deg" },
        { id: 2, tipo: "parede", status: false, x: 41, y: 66, rotate: "90deg" },
      ]
    },
    { 
      nome: "Salão de Festas", 
      espacoImg: espacoImageSalaoDeFestas1, 
      ares: [
        { id: 1, tipo: "teto", status: false, x: 46, y: 36, rotate: "0deg" },
        { id: 2, tipo: "teto", status: false, x: 10, y: 36, rotate: "0deg" },
        { id: 3, tipo: "teto", status: false, x: 28, y: 36, rotate: "0deg" },
      ]
    },
    { 
      nome: "Gourmet", 
      espacoImg: espacoImageGourmet, 
      ares: [
        { id: 1, tipo: "teto", status: false, x: 33, y: 20, rotate: "0deg" },
        { id: 2, tipo: "teto", status: false, x: 33, y: 60, rotate: "0deg" },
      ]
    },
    { 
      nome: "Academia", 
      espacoImg: espacoImageAcademia, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 57, y: 19, rotate: "90deg" },
        { id: 2, tipo: "parede", status: false, x: 26, y: 6, rotate: "0deg" },
        { id: 3, tipo: "parede", status: false, x: 43, y: 71, rotate: "90deg" },
        { id: 4, tipo: "parede", status: false, x: 26, y: 81, rotate: "180deg" },
        { id: 5, tipo: "parede", status: false, x: 43, y: 47, rotate: "90deg" },
      ]
    },
    { 
      nome: "Office", 
      espacoImg: espacoImageOffice, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 42, y: 22, rotate: "90deg" },
      ]
    }, {
      nome: "Market", 
      espacoImg: espacoImageMarket, 
      ares: [
        { id: 1, tipo: "parede", status: false, x: 13, y: 3, rotate: "0deg" },
      ]
    }
  ]);

  const handleExpand = (index) => {
    setExpandedIndex(index);
  };

  const handleCollapse = (event) => {
    event.stopPropagation();
    setExpandedIndex(null);
  };

  const toggleStatus = (espacoIndex) => {
    setEspacoArCondicionados((prevEspacos) => {
      const updatedEspacos = [...prevEspacos];
      const espacoAtual = updatedEspacos[espacoIndex];

      const algumLigado = espacoAtual.ares.some((arAtual) => arAtual.status);
      const acao = algumLigado ? "desligar" : "ligar";
      const nomeGrupo = espacoAtual.nome;

      espacoAtual.ares.forEach((arAtual) => {
        arAtual.status = !algumLigado;
        arAtual.isTemporary = true;
      });

      console.log(`Enviando comando para ${nomeGrupo} ${acao} todos os ares-condicionados`);
      comandoAr(nomeGrupo, acao)
        .then((response) => {
          console.log(`Ação ${acao} executada com sucesso para ${nomeGrupo}`);
        })
        .catch((error) => {
          console.error(`Erro ao executar a ação ${acao} para ${nomeGrupo}:`, error);
        });

      setTimeout(() => {
        espacoAtual.ares.forEach((arAtual) => {
          arAtual.isTemporary = false;
        });
        fetchStatusAr();
      }, 60000);

      return updatedEspacos;
    });
  };

  // Toggle individual AC
  const toggleIndividualAr = (espacoIndex, arId) => {
    setEspacoArCondicionados((prevEspacos) => {
      const updatedEspacos = [...prevEspacos];
      const espacoAtual = updatedEspacos[espacoIndex];
      const arAtual = espacoAtual.ares.find(ar => ar.id === arId);
      
      if (arAtual) {
        const acao = arAtual.status ? "desligar" : "ligar";
        const nomeGrupo = `${espacoAtual.nome}_${arId}`;
        
        arAtual.status = !arAtual.status;
        arAtual.isTemporary = true;
        
        console.log(`Enviando comando para ${nomeGrupo} ${acao}`);
        comandoAr(nomeGrupo, acao)
          .then((response) => {
            console.log(`Ação ${acao} executada com sucesso para ${nomeGrupo}`);
          })
          .catch((error) => {
            console.error(`Erro ao executar a ação ${acao} para ${nomeGrupo}:`, error);
          });
        
        setTimeout(() => {
          arAtual.isTemporary = false;
          fetchStatusAr();
        }, 60000);
      }
      
      return updatedEspacos;
    });
  };

  const fetchStatusAr = async () => {
    try {
      const response = await statusAr();
      console.log("Resposta original do servidor:", typeof response, response);
      
      // Se não recebemos resposta, saímos da função
      if (!response) {
        console.error("Servidor retornou resposta vazia ou nula");
        return;
      }
      
      // Tentamos converter a resposta para um formato utilizável
      let feedback = [];
      
      // Se for uma string, tentamos parsear como JSON
      if (typeof response === 'string') {
        try {
          feedback = JSON.parse(response);
          console.log("String convertida para objeto:", feedback);
        } catch (e) {
          console.error("Erro ao converter string para JSON:", e);
          return;
        }
      } 
      // Se for um objeto, verificamos se tem uma propriedade de array
      else if (typeof response === 'object') {
        if (Array.isArray(response)) {
          feedback = response;
        } 
        // Procuramos por uma propriedade que possa conter o array
        else {
          // Tenta encontrar uma propriedade que seja um array
          const possibleArrayProps = ['data', 'results', 'items', 'ares'];
          for (const prop of possibleArrayProps) {
            if (response[prop] && Array.isArray(response[prop])) {
              feedback = response[prop];
              console.log(`Encontrou array na propriedade '${prop}':`, feedback);
              break;
            }
          }
          
          // Se ainda não encontramos um array, tentamos converter o objeto em array
          if (feedback.length === 0) {
            feedback = Object.values(response);
            console.log("Convertendo objeto para array via Object.values:", feedback);
          }
        }
      }
      
      // Verificação final - se ainda não temos um array, criamos um vazio
      if (!Array.isArray(feedback)) {
        console.error("Não foi possível converter a resposta para um array:", response);
        feedback = [];
      }
      
      if (feedback.length === 0) {
        console.warn("Array de feedback está vazio");
        return;
      }
      
      // Agora podemos processar o array de feedback com segurança
      setEspacoArCondicionados((prevEspacos) => {
        const updatedEspacos = [...prevEspacos];

        updatedEspacos.forEach((espacoAtual) => {
          espacoAtual.ares.forEach((arAtual) => {
            if (!arAtual.isTemporary) {
              const normalizeString = (str) => {
                if (typeof str !== 'string') return '';
                return str.toLowerCase().trim();
              };
              
              // Busca no array de feedback com verificação segura das propriedades
              const feedbackItem = feedback.find(
                (item) => 
                  item && // Verifica se o item existe
                  item.nome && // Verifica se item.nome existe
                  normalizeString(item.nome) === normalizeString(espacoAtual.nome) &&
                  item.id === arAtual.id
              );

              if (feedbackItem) {
                arAtual.status = feedbackItem.status === "ON";
                console.log(`Status atualizado para ${espacoAtual.nome} - ${arAtual.id}: ${arAtual.status}`);
              } else {
                console.warn(`Nenhum status encontrado para ${espacoAtual.nome} - ${arAtual.id}`);
              }
            }
          });
        });

        return updatedEspacos;
      });
    } catch (error) {
      console.error("Erro ao obter o feedback de ar-condicionado:", error);
    }
  };

  // Initial fetch and setup polling for updates every 10 seconds
  useEffect(() => {
    // Initial fetch
    fetchStatusAr();
    
    // Set up polling for status updates every 10 seconds
    const intervalId = setInterval(() => {
      fetchStatusAr();
    }, 10000);

    // Clean up on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const getArImage = (tipo, status) => {
    if (tipo === "parede") {
      return status ? arParedeLigado : arParedeDesligado;
    } else if (tipo === "teto") {
      return status ? arTetoLigado : arTetoDesligado;
    }
    return null;
  };

  const todosEstaoLigados = (ares) => ares.every((ar) => ar.status);

  return (
    <div className="contentAr">
      <div className="espacoArCondicionado">
        {espacoArCondicionados.map((espaco, index) => (
          <div
            key={index}
            className={`arCondicionado ${expandedIndex === index ? "expanded" : ""}`}
            onClick={() => handleExpand(index)}
          >
            <h1 className={`tituloArCondicionado ${expandedIndex === index ? "expanded" : ""}`}>
              {espaco.nome}
            </h1>
            {expandedIndex === index && (
              <div className="AresCondicionados">
                <div className="botaoVoltarArCondicionado" onClick={handleCollapse}>
                  <img id="imgVoltar" src={voltar} alt="Retornar" />
                </div>
                <div className="espacoImage">
                  <img className="imagemEspacoArCondicionado" src={espaco.espacoImg} alt="Espaço" />
                  {espaco.ares.map((ar, arIndex) => (
                    <div key={arIndex} className="arCondicionadoImagem">
                      <img
                        className="imagemArCondicionado"
                        src={getArImage(ar.tipo, ar.status)}
                        alt="Ar Condicionado"
                        style={{ 
                          position: "absolute", 
                          left: `${ar.x}%`, 
                          top: `${ar.y}%`, 
                          transform: `rotate(${ar.rotate})`,
                          cursor: "pointer",
                          transition: "opacity 0.3s ease-in-out"
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleIndividualAr(index, ar.id);
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className="menuArCondicionado">
                  <div className="botaoLigarDesligarArCondicionado">
                    <p className="statusGrupoArCondicionados">
                      {todosEstaoLigados(espaco.ares) ? "Desligar Todos" : "Ligar Todos"}
                    </p>
                    <label className="switch-ar">
                      <input 
                        type="checkbox" 
                        checked={todosEstaoLigados(espaco.ares)}
                        onChange={() => toggleStatus(index)} 
                      />
                      <span className="slider-ar round"></span>
                    </label>
                  </div>
                  {espaco.ares.map((ar, arIndex) => (
                    <div key={arIndex} className="controleIndividualAr">
                      <div className="textArCondicionado">
                        <p className="tituloArCondicionado">Ar {ar.tipo} {ar.id}</p>
                        <div className="campobotaoArCondicionado">
                          <p className="statusArCondicionado">Status: {ar.status ? "Ligado" : "Desligado"}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArCondicionado;